var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskTemplate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.833 5.4H14.35A2.51 2.51 0 0 0 12 3.75c-1.083 0-2 .693-2.35 1.65H6.167C5.25 5.4 4.5 6.142 4.5 7.05V18.6c0 .907.75 1.65 1.667 1.65h11.666c.917 0 1.667-.742 1.667-1.65V7.05c0-.907-.75-1.65-1.667-1.65M12 5.4c.458 0 .833.371.833.825A.83.83 0 0 1 12 7.05a.83.83 0 0 1-.833-.825c0-.454.375-.825.833-.825m1.667 11.55H7.833V15.3h5.834zm2.5-3.3H7.833V12h8.334zm0-3.3H7.833V8.7h8.334z"
})));
export default SvgTaskTemplate;